export default __webpack_public_path__ + "static/inter-all-700-normal-4caa68a0cd07682d7af50a97f557c33d.woff";